export default __webpack_public_path__ + "5ea28c63816740ba8f8ac2a96f999cc3.png";